/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function DocumentIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "document", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M10.5 4.5H18.5V20.5H6.5V8.5L10.5 4.5Z", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M10.5 4.5V8.5H6.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(DocumentIcon);
export default ForwardRef;
//# sourceMappingURL=documentIcon.js.map